import { useCurrentClientManager } from './CurrentClientManager';
export const useRequiredAccountLevel = (requiredAccountLevels) => {
    const { selectedAccountLevel } = useCurrentClientManager();
    const hasRequiredAccountLevel = !requiredAccountLevels || requiredAccountLevels.includes(selectedAccountLevel);
    return {
        hasRequiredAccountLevel,
    };
};
